export default __webpack_public_path__ + "static/media/yelpTwo.b1443797.png";